import React, { useState, useEffect } from 'react';
import SidebarNav from './sidebar';
import YearlyStats from './YearlyStats';
import MonthlyStats from './MonthlyReport/monthlyStats';
import LatestAppointment from './LastestAppointment';
import Header from './header';
import Requests from "../pages/services/Requests";

const Dashboard = () => {
   const [dashboardData, setDashboardData] = useState({
      upcoming: 0,
      monthly: 0,
      clients: 0,
      all: 0
   });
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      const fetchData = async () => {
         try {
            const response = await Requests.getDashboardStats();

            if (response.data.success) {
               setDashboardData({
                  upcoming: response.data.data.totals.upcoming_appointments,
                  monthly: response.data.data.this_month.appointments,
                  clients: response.data.data.totals.unique_clients,
                  all: response.data.data.totals.appointments
               });
            }
         } catch (error) {
            console.error("Error fetching dashboard stats:", error);
         } finally {
            setLoading(false);
         }
      };

      fetchData();
   }, []);

   if (loading) {
      return (
         <div className="page-wrapper">
            <Header />
            <SidebarNav />
            <div className="content container-fluid">
               <div className="text-center loading-container">
                  <div className="spinner-border text-primary" role="status">
                     <span className="visually-hidden">Loading...</span>
                  </div>
               </div>
            </div>
         </div>
      );
   }

   return (
      <div className="page-wrapper">
         <Header />
         <SidebarNav />
         <div className="content container-fluid" style={{
            backgroundColor: '#d7f4da'
         }}>
            {/* Page Header */}
            <div className="page-header">
               <div className="row">
                  <div className="col-sm-12">
                     <h3 className="page-title">Welcome Hisa Admin!</h3>
                     <ul className="breadcrumb">
                        <li className="breadcrumb-item active">Appointments Dashboard</li>
                     </ul>
                  </div>
               </div>
            </div>

            {/* Stats Cards */}
            <div className="row">
               <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="dash-widget-header">
                           <span className="dash-widget-icon text-primary border-primary">
                              <i className="fe fe-bell" />
                           </span>
                           <div className="dash-count">
                              <h1>{dashboardData.upcoming}</h1>
                           </div>
                        </div>
                        <div className="dash-widget-info">
                           <h4 className="text-muted">Upcoming Appoinments</h4>
                           <div className="progress progress-sm">
                              <div className="progress-bar bg-primary w-50" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="dash-widget-header">
                           <span className="dash-widget-icon text-success">
                              <i className="fas fa-calendar-check" />
                           </span>
                           <div className="dash-count">
                              <h1>{dashboardData.monthly}</h1>
                           </div>
                        </div>
                        <div className="dash-widget-info">
                           <h4 className="text-muted">This Month appoinments</h4>
                           <div className="progress progress-sm">
                              <div className="progress-bar bg-success w-50" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="dash-widget-header">
                           <span className="dash-widget-icon text-danger border-danger">
                              <i className="fe fe-folder" />
                           </span>
                           <div className="dash-count">
                              <h2>{dashboardData.clients}</h2>
                           </div>
                        </div>
                        <div className="dash-widget-info">
                           <h4 className="text-muted">Total Clients</h4>
                           <div className="progress progress-sm">
                              <div className="progress-bar bg-danger w-50" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="dash-widget-header">
                           <span className="dash-widget-icon text-warning border-warning">
                              <i className="fe fe-users" />
                           </span>
                           <div className="dash-count">
                              <h2>{dashboardData.all}</h2>
                           </div>
                        </div>
                        <div className="dash-widget-info">
                           <h4 className="text-muted">All appoinments</h4>
                           <div className="progress progress-sm">
                              <div className="progress-bar bg-warning w-50" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Charts Section*/}
            <div className="row">
               <div className="col-md-12 col-lg-6">
                  <div className="card card-chart">
                     <div className="card-header">
                        <h4 className="card-title">Monthly performance</h4>
                     </div>
                     <div className="card-body">
                        <MonthlyStats />
                     </div>
                  </div>
               </div>
               <div className="col-md-12 col-lg-6">
                  {/* Sales Chart */}
                  <div className="card card-chart">
                     <div className="card-header">
                        <h4 className="card-title">Yearly performance</h4>
                     </div>
                     <div className="card-body">
                        <YearlyStats />
                     </div>
                  </div>
                  {/* /Sales Chart */}
               </div>
            </div>
            {/* Latest Customer */}
            <LatestAppointment />
         </div>
      </div>
   );
};

export default Dashboard;